import { useFormikContext } from 'formik';
import { useEffect } from 'react';

import { metrics } from '../../services';

const TrackFormDirty = ({ formComponent, isDirty, setIsDirty }) => {
  const { touched } = useFormikContext();
  useEffect(() => {
    if (touched && Object.keys(touched).length > 0 && !isDirty) {
      setIsDirty(true);
      metrics.trackLeadFormTouch(
        window.location.origin + window.location.pathname,
        formComponent,
        ''
      );
    }
  }, [touched, formComponent, isDirty, setIsDirty]);

  return null;
};

export default TrackFormDirty;
